/**
 * 入会申请人（apply 身份）的登录态存取。
 *
 * ⚠️ 刻意与官网账号密码登录态（accessToken / refreshToken / userInfo，userType="web"）分开存放：
 * 全局 axios 拦截器（utils/request.js）会无条件带上 Vuex 里的 accessToken，
 * 那是管理端身份，userType 与 apply 对不上 —— 申请人侧接口必须显式使用这里的 token，
 * 因此 memberApply 接口用的是独立 axios 实例（见 api/memberApply.js）。
 */

const KEY_ACCESS = 'applyAccessToken';
const KEY_REFRESH = 'applyRefreshToken';
const KEY_UNIONID = 'applyUnionid';

export function saveApplyAuth({ accessToken, refreshToken, unionid }) {
  if (accessToken) localStorage.setItem(KEY_ACCESS, accessToken);
  if (refreshToken) localStorage.setItem(KEY_REFRESH, refreshToken);
  if (unionid) localStorage.setItem(KEY_UNIONID, unionid);
}

export function getApplyAccessToken() {
  return localStorage.getItem(KEY_ACCESS) || '';
}

export function getApplyRefreshToken() {
  return localStorage.getItem(KEY_REFRESH) || '';
}

export function getApplyUnionid() {
  return localStorage.getItem(KEY_UNIONID) || '';
}

export function clearApplyAuth() {
  localStorage.removeItem(KEY_ACCESS);
  localStorage.removeItem(KEY_REFRESH);
  localStorage.removeItem(KEY_UNIONID);
}

/** unionid 后 4 位，用于页面顶部展示「已微信授权」标识 */
export function getApplyUnionidSuffix() {
  const unionid = getApplyUnionid();
  return unionid ? unionid.slice(-4) : '';
}
